export default __webpack_public_path__ + "static/media/react.2b6a0717.svg";